import React, { useEffect, useState, useRef } from 'react';

import countries from './../../../Translate/countries.json'

const CountryList = ({saveCountry, countryOnLoad, multilingua, language}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showList, setShowList] = useState(false);
  const dataCountries = ["af","al","dz","ad","ao","ag","ar","am","au","at","az","bs","bh","bd","bb","by","be","bz","bj","bt","bo","ba","bw","br","bn","bg","bf","bi","cv","kh","cm","ca","cf","td","cl","cn","co","km","cg","cr","hr","cu","cy","cz","cd","dk","dj","dm","do","tl","ec","eg","sv","gq","er","ee","sz","et","fj","fi","fr","ga","gm","ge","de","gh","gr","gd","gt","gn","gw","gy","ht","hn","hu","is","in","id","ir","iq","ie","il","it","ci","jm","jp","jo","kz","ke","ki","xk","kw","kg","la","lv","lb","ls","lr","ly","li","lt","lu","mg","mw","my","mv","ml","mt","mh","mr","mu","mx","fm","md","mc","mn","me","ma","mz","mm","na","nr","np","nl","nz","ni","ne","ng","kp","mk","no","om","pk","pw","ps","pa","pg","py","pe","ph","pl","pt","qa","ro","ru","rw","kn","lc","vc","ws","sm","st","sa","sn","rs","sc","sl","sg","sk","si","sb","so","za","kr","ss","es","lk","sd","sr","se","ch","sy","tw","tj","tz","th","tg","to","tt","tn","tr","tm","tv","ug","ua","ae","gb","us","uy","uz","vu","va","ve","vn","ye","zm","zw"];
  // const countries = ["Afghanistan","Albania","Algeria","Andorra","Angola","Antigua and Barbuda","Argentina","Armenia","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei","Bulgaria","Burkina Faso","Burundi","Cabo Verde","Cambodia","Cameroon","Canada","Central African Republic","Chad","Chile","China","Colombia","Comoros","Congo","Costa Rica","Croatia","Cuba","Cyprus","Czech Republic","Democratic Republic of the Congo","Denmark","Djibouti","Dominica","Dominican Republic","East Timor (Timor-Leste)","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia","Fiji","Finland","France","Gabon","Gambia","Georgia","Germany","Ghana","Greece","Grenada","Guatemala","Guinea","Guinea-Bissau","Guyana","Haiti","Honduras","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy","Ivory Coast","Jamaica","Japan","Jordan","Kazakhstan","Kenya","Kiribati","Kosovo","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Morocco","Mozambique","Myanmar (Burma)","Namibia","Nauru","Nepal","Netherlands","New Zealand","Nicaragua","Niger","Nigeria","North Korea","North Macedonia (Macedonia)","Norway","Oman","Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Qatar","Romania","Russia","Rwanda","Saint Kitts and Nevis","Saint Lucia","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Korea","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Togo","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan","Vanuatu","Vatican City","Venezuela","Vietnam","Yemen","Zambia","Zimbabwe"];
  const handleInputChange = (event) => {
    const value = event.target.value;
    saveCountry(value);
    setSearchTerm(value);    
    setShowList(true);
  };

  const handleItemClick = (country) => {
    saveCountry(dataCountries[countries[language].indexOf(country)]);
    setSearchTerm(country);
    setShowList(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
        if(showList && !e.target.closest('.user-info-input') && !e.target.closest('.country-list')){
            setShowList(false);
        }
    }

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);    
    }
  })
  useEffect(() => {
    dataCountries.forEach(elem => {
      if (elem === countryOnLoad) setSearchTerm(countries[language][dataCountries.indexOf(elem)]);
    })
  }, [countryOnLoad])  

  
  const Ref = useRef(null);
  const [leftPosition, setLeftPosition] = useState('0');
  const calculateLeftPosition = () => {
    if (Ref.current) {
      const buttonRect = Ref.current.getBoundingClientRect();
      const containerRect = Ref.current.parentElement.getBoundingClientRect();
      const position = buttonRect.left - containerRect.left;
      return `${position}px`;
    }
    return '0';
  };
  useEffect(() => {
    setLeftPosition(calculateLeftPosition());
  }, [showList]);
  return (
    <div className="user-country columnize" >
      {multilingua} <input
        className="user-info-input"
        type="text"
        onClick={() => showList === false ? setShowList(true) : setShowList(false)}
        onChange={handleInputChange}
        value={searchTerm}
        ref={Ref}
      />
      {showList && (
        <div className='country-list' style={{left: leftPosition}}>
            {countries[language].filter((country) =>
                country.toLowerCase().startsWith(searchTerm.toLowerCase())
              ).map((country, index) => ( 
                  <div
                    className='country-list-item'
                    key={index}
                    onClick={() => handleItemClick(country)}
                  >
                    { country }
                  </div>
              ))} 
              
        </div>
      )}
    </div>
  );
};

export default CountryList;
